import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_account_conciliation'

const generateConciliation = async (object) => {
    try {
        const response = await axios.post(
            route,
            object
        )
        return response.data
    } catch (error) {
        error.response.data
    }
}

export default generateConciliation
